<template>
  <div class="row">
    <div class="col-md-12 col-xxl-12 col-sm-12 mb-10">
      <div class="card mb-25 border-0 rounded-0">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <h4 class="position-relative text-black fw-bold mb-10">Informations de l'étudiant</h4>
            <router-link to="/liste-demande-inscriptions" 
                         class="btn btn-primary transition border-0 lh-1 fw-medium">
              <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
              Retour
            </router-link>
          </div>

          <table class="table table-bordered">
            <tbody>
              <!-- Informations personnelles -->
              <tr v-if="demande?.nom">
                <td><strong>Nom :</strong></td>
                <td>{{ demande?.nom }}</td>
              </tr>
              <tr v-if="demande?.prenom">
                <td><strong>Prénoms :</strong></td>
                <td>{{ demande?.prenom }}</td>
              </tr>
              <tr v-if="demande?.sexe">
                <td><strong>Sexe :</strong></td>
                <td>{{ demande?.sexe }}</td>
              </tr>
              <tr v-if="demande?.dateNaissance">
                <td><strong>Date de naissance :</strong></td>
                <td>{{ formatDate(demande?.dateNaissance) }}</td>
              </tr>
              <tr v-if="demande?.lieuNaissance">
                <td><strong>Lieu de naissance :</strong></td>
                <td>{{ demande?.lieuNaissance }}</td>
              </tr>
              <tr v-if="demande?.nationalite">
                <td><strong>Pays de résidence :</strong></td>
                <td>{{ demande?.nationalite }}</td>
              </tr>

              <!-- Contact -->
              <tr v-if="demande?.email">
                <td><strong>Email :</strong></td>
                <td>{{ demande?.email }}</td>
              </tr>
              <tr v-if="demande?.telephone1">
                <td><strong>Téléphone 1 :</strong></td>
                <td>{{ demande?.telephone1 }}</td>
              </tr>
              <tr v-if="demande?.whatsapp">
                <td><strong>WhatsApp :</strong></td>
                <td>{{ demande?.whatsapp }}</td>
              </tr>
              <tr v-if="demande?.adresse">
                <td><strong>Adresse :</strong></td>
                <td>{{ demande?.adresse }}</td>
              </tr>

              <!-- Localisation -->
              <tr v-if="demande?.commune">
                <td><strong>Commune :</strong></td>
                <td>{{ demande?.commune }}</td>
              </tr>
              <tr v-if="demande?.quartier?.nom">
                <td><strong>Quartier :</strong></td>
                <td>{{ demande?.quartier?.nom }}</td>
              </tr>

              <!-- Formation & Statut -->
              <tr v-if="demande?.qualification?.libelle">
                <td><strong>Niveau d'étude :</strong></td>
                <td>{{ demande?.qualification?.libelle }}</td>
              </tr>
              <tr v-if="demande?.anneeExperience !== null && demande?.anneeExperience !== undefined">
                <td><strong>Années d'expérience :</strong></td>
                <td>{{ demande?.anneeExperience }} an(s)</td>
              </tr>
              <tr v-if="demande?.profession">
                <td><strong>Profession :</strong></td>
                <td>{{ demande?.profession }}</td>
              </tr>

              <!-- Situation religieuse / sociale -->
              <tr v-if="demande?.baptise !== null && demande?.baptise !== undefined">
                <td><strong>Baptisé(e) :</strong></td>
                <td>{{ demande?.baptise}}</td>
              </tr>
              <tr v-if="demande?.paroisse">
                <td><strong>Paroisse :</strong></td>
                <td>{{ demande?.paroisse }}</td>
              </tr>
              <tr v-if="demande?.groupeAssociation">
                <td><strong>Groupe / Association :</strong></td>
                <td>{{ demande?.groupeAssociation }}</td>
              </tr>
              <tr v-if="demande?.situationMatrimoniale">
                <td><strong>Situation matrimoniale :</strong></td>
                <td>{{ demande?.situationMatrimoniale }}</td>
              </tr>

              <!-- Formation théologie -->
              <tr v-if="demande?.formationTheologie">
                <td><strong>Formation en théologie déjà suivie :</strong></td>
                <td>{{ demande?.formationTheologie }}</td>
              </tr>
              <tr v-if="demande?.formationEnLigne">
                <td><strong>Voulez-vous suivre une formation en ligne ?</strong></td>
                <td>{{ demande?.formationEnLigne }}</td>
              </tr>

              <!-- Activités -->
              <tr v-if="demande?.activites && demande?.activites.length">
                <td><strong>Activités :</strong></td>
                <td>{{ demande?.activites.join(', ') }}</td>
              </tr>

              <!-- Horaires -->
              <tr v-if="demande?.horaires && demande?.horaires.length">
                <td><strong>Horaires souhaités :</strong></td>
                <td>
                  <ul class="list-unstyled mb-0">
                    <li v-for="(horaire, index) in demande.horaires" :key="index" class="mb-1">
                      • {{ horaire }}
                    </li>
                  </ul>
                </td>
              </tr>

              <!-- Biographie -->
              <tr v-if="demande?.biographie">
                <td><strong>Informations complémentaires :</strong></td>
                <td style="white-space: pre-wrap;">{{ demande?.biographie }}</td>
              </tr>

              <tr v-if="demande?.numeroMatricule">
                <td><strong>Numéro Matricule :</strong></td>
                <td>{{ demande?.numeroMatricule }}</td>
              </tr>
              <tr v-if="demande?.filiere?.libelle">
                <td><strong>Filière :</strong></td>
                <td>{{ demande?.filiere?.libelle }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/services/ApiService";
import { useRoute } from "vue-router";
import { error } from "@/utils/utils";

export default defineComponent({
  name: "ViewDemandeInscription",
  setup() {
    const route = useRoute();
    const demande = ref<any>(null);

    const formatDate = (date: string | Date) => {
      if (!date) return '';
      return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      }).format(new Date(date));
    };

    const getDemandeInscription = async (id: string) => {
      try {
        const { data } = await ApiService.get(`/demandes/${id}`);
        demande.value = data.data;
      } catch (err: any) {
        error(err.response?.data?.message || "Erreur lors du chargement de la demande");
      }
    };

    onMounted(() => {
      const id = route.params.id as string;
      if (id) {
        getDemandeInscription(id);
      }
    });

    return { 
      demande,
      formatDate
    };
  }
});
</script>